import { getEffectiveQuantityPrecision, getProduct } from '#/products/domain';

export function normalize(
  productCode: string,
  quantity: number,
  isDated = false,
  precisionOverride?: number,
): string {
  const precision =
    precisionOverride ??
    getEffectiveQuantityPrecision(getProduct(productCode), isDated);
  const normalizeQty = (qty: number) => qty.toFixed(precision);

  return normalizeQty(quantity);
}
